import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loginModalHandler, loginModule } from './LoginDucks';
import Modal from '../../_ui/Modal/Modal';
import DefaultLogin from './DefaultLogin';
import LoginWithECP from './LoginWithECP';
import './LoginTranslate';

function renderLoginMethod(integrationModal) {
  const isWithoutECP = localStorage.getItem('authWithoutSignature');
  if (isWithoutECP === 'true') {
    return <DefaultLogin integrationModal={integrationModal} />;
  }
  return <LoginWithECP integrationModal={integrationModal} />;
}

function Login({ integrationModal }) {
  const { isOpen } = useSelector(state => state[loginModule]);
  const dispatch = useDispatch();

  return (
    <Modal
      open={isOpen}
      onClose={() => dispatch(loginModalHandler(false))}
      children={renderLoginMethod(integrationModal)}
    />
  );
}

export default Login;
